import React, {useContext, useState} from 'react';
import Form from "react-bootstrap/Form";
import Icon from "@reacticons/bootstrap-icons";
import {Context} from "../../index";
import {useIntl} from "react-intl";


const ContainerRowEdit = (props) => {
    const {store} = useContext(Context);
    const intl = useIntl();
    const row = props.row;
    const contentName = row.content === 'F'
        ? intl.messages.fullc
        : row.content === 'E' ? intl.messages.empty : '—';
    const issued = props.lockVehicleOnAnyMovement
        ? Boolean(row.moving)
        : Number(row.moving_status) >= 2;
    const vehicleReadOnly = !props.editableVehicle || issued;
    const handleChange = (e,name) => {
        props.handleChange(e.target.value,name, props.index);
    }
    const handleChangeContainer = (e) => {

        if(e.target.value.length > 0 && e.target.value < 11){
            e.target.setCustomValidity("incorect number");
        } else if(store.testContainer(e.target.value) === false){
            e.target.setCustomValidity("incorect number");
        } else {
            e.target.setCustomValidity("");
        }
        handleChange(e,'number')
    }



    const type = store.type;

    return (
        <tr className={issued ? 'table-secondary' : ''}>
            <td>

            </td>

            <td>
                <Form.Select disabled value={row.type} onChange={e => handleChange(e, 'type')}>
                    <option></option>
                    {type.map((s, i) =>
                        <option key={i} value={s.id}>{s.name}</option>
                    )}
                </Form.Select>
            </td>

            <td>
                {props.showOrderedCount
                    ? <Form.Control readOnly value={row.count ?? ''} type="number"/>
                    : <Form.Control readOnly className="container_test" value={row.number} type="text" placeholder=""/>}
            </td>
            {props.showContent ? <td><Form.Control value={contentName} readOnly/></td> : null}
            {props.numberOut ? <td><Form.Control value={row.out_time ?? ''} readOnly/></td> : null}
            {props.showStatus ? <td><Form.Control value={row.out_status_label ?? ''} readOnly/></td> : null}
            <td>
                <Form.Control
                    disabled={vehicleReadOnly}
                    type="text"
                    value={row.car_number ?? ''}
                    onChange={e => handleChange(e, 'car_number')}
                />


            </td>
            <td>
                <Form.Control
                    disabled={vehicleReadOnly}
                    value={row.fio ?? ''}
                    onChange={e => handleChange(e, 'fio')}
                    type="text"
                    placeholder=""
                />
            </td>
            <td>
                {row.moving ? true :  !props.del ? '' :
                    <a href="#" className="text-warning" onClick={(e) => props.delete(e, props.index)}>
                        <Icon name="trash"/>
                    </a>
                }
            </td>
        </tr>
    );
}

export default ContainerRowEdit;
